// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-0676cafc] {\n  height: calc(100vh - 126px);\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
